import { MediaManagerSDKFolder } from '../../../media-manager-sdk';

export enum ClickOrigin {
  InfoPanel = 'more_info',
  Actions = 'actions',
  LeftArrow = 'left_arrow',
  RightArrow = 'right_arrow',
  PreviewBottomNavigation = 'preview_bottom_navigation',
  Breadcrumbs = 'breadcrumbs',
  TopRight = 'top_right',
  MoveTo = 'move_to',
  EmptyFolderOrFilter = 'empty_folder_or_filter',
}

export enum CreateFolderAction {
  Started = 'started',
  Created = 'created',
}

export interface IWithTrackSiteFilesAnalyticsOuter {}

export interface IHandlers {
  trackFolderCreateStart(): (origin: ClickOrigin) => void;
  trackFolderCreated(): (folderId: string, origin: ClickOrigin) => void;
  trackCreateFolderFromMoveToClicked: (folder: MediaManagerSDKFolder) => void;
  trackBreadcrumbsClick(fileId: string, kind: 'file' | 'folder'): () => void;
}

export interface IInnerHandlers extends IHandlers {}

export interface IWithTrackSiteFilesAnalyticsInner extends IInnerHandlers {}
